import styles from './W_NotificationEmptyContainer.module.css';
import W_NotificationEmptyContainerImage from '@/assets/images/W_NotificationEmptyContainer.png';
import cn from 'classnames';
import { useTranslation } from '@/hooks/useTranslation';

interface W_NotificationEmptyContainerProps {
  filterType?: 'unread' | 'read' | 'all';
}

export default function W_NotificationEmptyContainer({
  filterType = 'unread',
}: W_NotificationEmptyContainerProps) {
  const t = useTranslation();

  const getMessage = () => {
    switch (filterType) {
      case 'unread':
        return t('profileNotifications.emptyUnread');
      case 'read':
        return t('profileNotifications.emptyRead');
      case 'all':
        return t('profileNotifications.emptyAll');
      default:
        return t('profileNotifications.emptyUnread');
    }
  };

  return (
    <div className={styles.wrapper}>
      <img
        src={W_NotificationEmptyContainerImage}
        alt='empty'
        className={styles.image}
      />
      <p className={cn(styles.text, 'text-p-2')}>{getMessage()}</p>
    </div>
  );
}
